// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog_container {
  text-align: justify;
  max-width: 600px;
}

div [mat-dialog-title] {
  display: flex;
  justify-content: center;
  align-items: center;
}

mat-dialog-actions {
  justify-content: center;
  margin: 12px 0 0 0;
}

.delete-color {
  color: #fff;
  background-color: #A72925;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/dialogs/deletion-dialog/deletion-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,uBAAA;EACA,kBAAA;AACF;;AAGA;EACE,WAAA;EACA,yBAAA;AAAF","sourcesContent":[".dialog_container {\r\n  text-align: justify;\r\n  max-width: 600px;\r\n}\r\n\r\ndiv [mat-dialog-title] {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center ;\r\n}\r\n\r\nmat-dialog-actions {\r\n  justify-content: center;\r\n  margin: 12px 0 0 0 ;\r\n}\r\n\r\n\r\n.delete-color{\r\n  color: #fff;\r\n  background-color: #A72925;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
